var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 24,
    height: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2544_1997)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2544_1997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.20898 20.7021V9.23072L12.0581 2.30362L21.9072 9.23072V20.7021C21.9072 21.2616 21.3726 21.8823 20.4963 21.8823H3.6199C2.74362 21.8823 2.20898 21.2616 2.20898 20.7021Z",
    stroke: "#F41106",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85693 20.9252V10.9171H15.2587V20.9252",
    stroke: "#F41106",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2544_1997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6982,
    height: 21.8012,
    fill: "white",
    transform: "translate(1.20898 1.08105)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2544_1997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6982,
    height: 21.8012,
    fill: "white",
    transform: "translate(1.20898 1.08105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRed);
export default __webpack_public_path__ + "static/media/homeRed.057cd2bab99f1a7d4b341d0cfa1b61d8.svg";
export { ForwardRef as ReactComponent };